"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EngineModuleState = void 0;
var EngineModuleState;
(function (EngineModuleState) {
    EngineModuleState["NOT_BOOTSTRAPPED"] = "NOT_BOOTSTRAPPED";
    EngineModuleState["BOOTSTRAPING"] = "BOOTSTRAPING";
    EngineModuleState["NOT_MOUNTED"] = "NOT_MOUNTED";
    EngineModuleState["MOUNTED"] = "MOUNTED";
    EngineModuleState["UNMOUNTING"] = "UNMOUNTING";
    EngineModuleState["UPDATING"] = "UPDATING";
    EngineModuleState["SKIP_BECAUSE_BROKEN"] = "SKIP_BECAUSE_BROKEN";
})(EngineModuleState = exports.EngineModuleState || (exports.EngineModuleState = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW5naW5lLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2VuZ2luZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFvREEsSUFBWSxpQkFRWDtBQVJELFdBQVksaUJBQWlCO0lBQzNCLDBEQUFxQyxDQUFBO0lBQ3JDLGtEQUE2QixDQUFBO0lBQzdCLGdEQUEyQixDQUFBO0lBQzNCLHdDQUFtQixDQUFBO0lBQ25CLDhDQUF5QixDQUFBO0lBQ3pCLDBDQUFxQixDQUFBO0lBQ3JCLGdFQUEyQyxDQUFBO0FBQzdDLENBQUMsRUFSVyxpQkFBaUIsR0FBakIseUJBQWlCLEtBQWpCLHlCQUFpQixRQVE1QiJ9